export default function getFallbackValueIfNull<T>(value: T, fallback: T) {
    // We need to deal with both null and undefined
    return value == null ? fallback : value;
}
